// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2TN6U","easyZoom":"styles_easyZoom__27CJs","modalFade":"styles_modalFade__NhN9F","modalLeftRight":"styles_modalLeftRight__2O-Dz"};